<header class="h-16 bg-surface-card border-b border-stone-200/80 px-4 sm:px-8 flex items-center justify-between sticky top-0 z-20 shrink-0">
  <!-- Left: Mobile Hamburger + Client Selector Pill -->
  <div class="flex items-center gap-3">
    <!-- Mobile Hamburger Button -->
    <button
      type="button"
      (click)="toggleMobileSidebar.emit()"
      class="lg:hidden p-2 -ml-1 text-stone-600 hover:text-primary hover:bg-surface rounded-xl transition-colors focus:outline-none cursor-pointer"
      title="Menu"
    >
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>

    <!-- Client Badge (Static Display) -->
    <div
      class="flex items-center gap-2 px-3.5 py-1.5 rounded-xl bg-surface/60 border-[1px] border-solid border-stone-200/90 select-none"
    >
      <!-- <span class="text-xs font-medium text-stone-500">
        {{ 'BACKOFFICE.HEADER.CLIENT_LABEL' | translate }}
      </span> -->
      <img
        [src]="customerLogo || defaultImage"
        [alt]="customerName || 'Client'"
        class="w-6 h-6 rounded-full object-cover border border-stone-200 bg-surface-card shrink-0"
      />
      <span class="text-xs sm:text-sm font-bold text-primary truncate max-w-[180px] sm:max-w-[240px]">
        {{ customerName || '—' }}
      </span>
    </div>
  </div>

  <!-- Right: Language, Notifications, Divider & User Profile -->
  <div class="flex items-center gap-3 sm:gap-4">
    <!-- Language Selector (Commenté)
    <div class="relative" #langDropdownRef>
      <button
        type="button"
        (click)="toggleLangMenu($event)"
        class="p-2 text-stone-500 hover:text-primary hover:bg-surface rounded-xl transition-colors flex items-center gap-1.5 cursor-pointer"
        [title]="'BACKOFFICE.HEADER.LANGUAGE' | translate"
      >
        <svg class="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M2 12h20" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
        <span class="text-xs font-bold uppercase hidden sm:inline">{{ currentLang }}</span>
      </button>

      @if (showLangMenu) {
        <div
          class="absolute right-0 top-full mt-2 w-40 bg-surface-card rounded-2xl shadow-dropdown border-[1px] border-stone-200/90 p-1.5 z-50 animate-fade-in"
        >
          <button
            type="button"
            (click)="changeLanguage('fr')"
            class="w-full flex items-center justify-between px-3 py-2 text-xs font-semibold rounded-xl transition cursor-pointer"
            [ngClass]="{
              'bg-primary-50 text-primary font-bold': currentLang === 'fr',
              'text-stone-600 hover:bg-surface': currentLang !== 'fr'
            }"
          >
            <div class="flex items-center gap-2">
              <span>🇫🇷</span>
              <span>Français</span>
            </div>
            @if (currentLang === 'fr') {
              <svg class="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
              </svg>
            }
          </button>

          <button
            type="button"
            (click)="changeLanguage('en')"
            class="w-full flex items-center justify-between px-3 py-2 text-xs font-semibold rounded-xl transition cursor-pointer mt-0.5"
            [ngClass]="{
              'bg-primary-50 text-primary font-bold': currentLang === 'en',
              'text-stone-600 hover:bg-surface': currentLang !== 'en'
            }"
          >
            <div class="flex items-center gap-2">
              <span>🇬🇧</span>
              <span>English</span>
            </div>
            @if (currentLang === 'en') {
              <svg class="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
              </svg>
            }
          </button>
        </div>
      }
    </div>

    <div class="h-6 w-[1px] bg-stone-200"></div>
    -->

    <!-- User Profile & Logout Dropdown (matching mockup: Name + Role + Circular Avatar) -->
    <div class="relative" #userDropdownRef>
      <button
        type="button"
        (click)="toggleUserMenu($event)"
        class="flex items-center gap-3 py-1 px-1.5 rounded-xl hover:bg-surface transition-colors focus:outline-none cursor-pointer"
      >
        <div class="hidden sm:flex flex-col items-end text-right">
          <span class="text-sm font-bold text-stone-800 leading-tight truncate max-w-[160px]">
            {{ getUserDisplayName() }}
          </span>
          <!-- <span class="text-xs text-stone-500 leading-tight mt-0.5">
            {{ getUserRoleLabel() | translate }}
          </span> -->
        </div>

        <!-- Circular Avatar with User Icon (as in mockup) -->
        <div
          class="w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center shadow-subtle shrink-0"
        >
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="8" r="4" />
            <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
          </svg>
        </div>
      </button>

      <!-- User Profile Dropdown Menu -->
      @if (showUserMenu) {
        <div
          class="absolute right-0 top-full mt-2 w-56 bg-surface-card rounded-2xl shadow-dropdown border-[1px] border-stone-200/90 p-1.5 z-50 animate-fade-in"
        >
          <div class="px-3 py-2.5 border-b border-stone-100 mb-1">
            <p class="text-xs font-bold text-stone-800 truncate">
              {{ getUserDisplayName() }}
            </p>
            @if (currentUser?.email) {
              <p class="text-[11px] text-stone-500 truncate mt-0.5">
                {{ currentUser.email }}
              </p>
            }
          </div>

          <button
            type="button"
            (click)="onLogout()"
            class="w-full flex items-center gap-2.5 px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-xl transition-colors cursor-pointer"
          >
            <svg class="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            <span>{{ 'BACKOFFICE.NAV.LOGOUT' | translate }}</span>
          </button>
        </div>
      }
    </div>
  </div>
</header>

